import { css } from 'styled-components';
import { CFTokens } from '../../tokens';
export const CFBaseSegmentControlsHelpers = {
    rootBackground: ({ $variant = 'default', }) => {
        return $variant === 'alternate'
            ? CFTokens.COLOR.MONO_9
            : CFTokens.COLOR.BACKGROUND_COOL_1;
    },
};
export const CFBaseSegmentControlsStyles = {
    Root: css `
    padding: ${CFTokens.SPACER.A}px;
    display: flex;
    flex-direction: row;
    gap: ${CFTokens.SPACER.A}px;
    background-color: ${CFBaseSegmentControlsHelpers.rootBackground};
    border-radius: ${CFTokens.BORDER_RADIUS.PILL}px;
  `,
};
